import axios from 'axios';
import React from 'react';
import '../Styles.css';
import { jwtDecode } from "jwt-decode";

function AuthGoogle() {
    var url;
    
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/auth/google', {}, {
        headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        console.log(response);
        window.location.href = response.data.url;
    })
    .catch(error => {
        console.log(error);
    });
}

function AuthLogin() {
    document.getElementById("Chg").style.display = "block";
    document.getElementById("Btn").style.display = "none";

    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/auth/login', {
        Email: document.getElementById("email").value,
        Password: document.getElementById("password").value,
        }, {
            headers: {
                'Content-Type': 'text/plain',
            },
        }
    ).then(response => {
        const token = response.data.token;
        const decode = jwtDecode(token)

        localStorage.setItem("token", token);

        switch (decode.role) {
            case 0:
                window.location.href = '/super-usuario';
                break;
            case 1:
                window.location.href = '/administrador';
                break;
            case 2:
                window.location.href = '/invitador';
                break;
            case 3:
                window.location.href = '/proveedor';
                break;
            default: 
                window.location.href = '/';
                break;
        }
    })
    .catch(error => {
        localStorage.removeItem("token");
        document.getElementById("Chg").style.display = "none";
        document.getElementById("Btn").style.display = "inline-block";
        document.getElementById("message").innerHTML = error.response.data.error;
        document.getElementById("message").style.color = "red";
        document.getElementById("email").value = error.response.data.email;
    });
}

export function Logout() {
    localStorage.removeItem("token");
    window.location.href = '/';
    return;
}

function Login() {
    return (
        <div className='Container'>
            <div className='Login rounded'>
                <div className='row rounded shadow-lg'>
                    <div className='col-lg-5 Welcome gone'>
                        <div className='text-center'>
                            <img src='./img/logo-herdez-white.png' width='180px' className='mb-4' alt='Grupo Herdez'></img>
                            <h1 className='text-white'>Bienvenido</h1>
                            <br></br>
                            <p className='text-white'>
                                Portal de proveedores de 
                                <br></br>
                                Grupo Herdez
                            </p>
                        </div>
                    </div>
                    <div className='col-lg-7 Form'>
                        <div className='text-center'>
                            <br></br>
                            <br></br>
                            <br></br>
                            <h1 className='text-center Text-Red'>Login</h1>
                            <br></br>
                            <p className='Text-Gray'>
                                Inicia sesión con tu cuenta de Google
                            </p> 
                            <img src='./img/google-button.png' width='200px' alt='Google login' onClick={AuthGoogle}></img>
                            <br></br>
                            <br></br>
                            <p className='Text-Gray'>
                                Ingresa tu usuario y contraseña
                            </p>
                            <form action={AuthLogin}>
                                <p id='message' className='Text-red'></p>
                                <input type='email' id='email' placeholder='Email' className='Input-Style'></input>
                                <br></br>
                                <input type='password' id='password' placeholder='Password' className='Input-Style'></input>
                                <br></br>
                                <i id="Chg"className="fa fa-spinner fa-spin Chg"></i>
                                <input id='Btn' type='submit' value='Ingresar' className='Button-Style'></input>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;